import React from 'react'
import {
  Popover,
  Pane,
  Text,
  Button,
  ArrowLeftIcon,
  BanCircleIcon
} from 'evergreen-ui'

const ConfirmationPopOver = ({
  children,
  text = 'Are you sure?',
  confirmButtonText = 'Yes',
  confirmButtonIcon,
  confirmButtonIntent = 'danger',
  confirmationHandler
}) => {
  return (
    <Popover
      content={({ close }) => (
        <Pane maxWidth={300} padding={30}>
          <Text>{text}</Text>
          <Pane display='flex' justifyContent='space-between' marginTop={20}>
            <Button iconBefore={ArrowLeftIcon} onClick={close}>
              Nope
            </Button>
            <Button
              iconBefore={confirmButtonIcon || BanCircleIcon}
              intent={confirmButtonIntent}
              onClick={() => confirmationHandler()}
            >
              {confirmButtonText}
            </Button>
          </Pane>
        </Pane>
      )}
    >
      {children}
    </Popover>
  )
}

export default ConfirmationPopOver
